<div #wrapper id="ush-showtimes-widget-wrapper" [attr.data-flow]="showtimesFlow()">
  <ng-container *ngIf="!disableShowtimes">
    <div class="ush-showtimes-wrapper">
      <div class="ush-showtimes-header">
        <ush-location-selector
          #locationSelector
          (locationSelected)="handleLocationSelected($event)"
          [enableRouterNavigation]="enableRouterNavigation"
        ></ush-location-selector>

        @if (!hasLocation()) {
          <div class="tab-msg ush-error-msg text" i18n="@@public.commons.noLocation">No location</div>
        }

        <!-- DATE SHOWTIME FLOW -->
        @if (showTimeDates && hasLocation() && isDateFlow()) {
          <div class="showtime-dates">
            <ush-showtime-dates
              [style.display]="previousPerformanceUiCount() > 0 ? 'block' : 'none'"
              [dates]="showTimeDates"
              (dateInitialized)="updateCinemaListOnDateChange($event)"
              (dateSelected)="updateCinemaListOnDateChange($event, true)"
            ></ush-showtime-dates>
          </div>
        }
      </div>
      <!-- DATE SHOWTIME FLOW -->
      @if (hasLocation() && isDateFlow()) {
        @if (!loadingShowtimes()) {
          <div class="ush-showtimes-loaded">
            @if (isPerformancesUiEmpty()) {
              <div
                class="tab-msg ush-error-msg text"
                [innerHTML]="errorMsg() || '' | safe: 'html'"
                [attr.data-translate]="errorKey()"
              ></div>
            } @else if (isBrowser) {
              <div class="showtime-list" [@listAnimation]="performancesUiVisible().length">
                @for (performance of performancesUiVisible(); track performance.cinema.id; let i = $index) {
                  <div class="performance-wrapper" [id]="'cinema-wrapper-' + performance?.cinema?.id">
                    <ush-performance-header [performance]="performance" />
                    <ush-performance
                      [date]="dateSelected"
                      [perfGroup]="performance"
                      [showtimesFlow]="showtimesFlow()"
                      hideAddress
                    />
                  </div>
                }
              </div>
            } @else {
              <div class="showtime-list" [style.min-height.px]="previousPerformanceUiCount() * 145"></div>
            }

            @if (!allPerformancesUiVisible()) {
              <ush-load-more-cinemas (click)="loadMore()" />
            }

            <div class="ush-showtimes-nearestCities-wrapper" *ngIf="!diasbleNearestCities && nearestCities?.length > 0">
              <p class="ush-showtimes-nearestCities-title" i18n-attr="@@public.commons.nearestCities.availableAt">
                <span
                  data-translate="public.commons.nearestCities.availableAt"
                  i18n="@@public.commons.nearestCities.availableAt"
                >
                  {{ 'public.commons.nearestCities.availableAt' | rt: 'Showtimes also available at' }}</span
                >
              </p>
              <ul class="ush-showtimes-nearestCities-list">
                <li class="ush-showtimes-nearestCities-item" *ngFor="let city of nearestCities">
                  <button class="ush-showtime-nearestCities-btn button" (click)="onNearCitySelected(city)">
                    {{ city.name }} ({{ city.formatDistance }})
                  </button>
                </li>
              </ul>
            </div>
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="loading" />
        }
      }
      <!-- END DATE SHOWTIME FLOW -->

      <!-- LOCATION SHOWTIME FLOW -->
      @if (hasLocation() && showtimesFlow() === 'location') {
        @if (!loadingShowtimes()) {
          <div class="ush-showtimes-loaded">
            @if (isPerformancesEmpty()) {
              <div
                class="tab-msg ush-error-msg text"
                [innerHTML]="errorMsg() | safe: 'html'"
                [attr.data-translate]="errorKey()"
              ></div>
            } @else {
              <p-accordion
                (onOpen)="onCinemaOpened($event)"
                (onClose)="onCinemaClosed()"
                [expandIcon]="null"
                [collapseIcon]="null"
                [styleClass]="'showtime-list'"
                [activeIndex]="indexPanelToOpen"
              >
                @for (performance of performancesVisible(); track performance.id; let i = $index) {
                  <p-accordionTab #tab [@fadeInOut]>
                    <ng-template pTemplate="header">
                      <div class="showtime-cinema-wrapper old-flow" [ngClass]="{ active: i === currentIndex }">
                        <div class="showtime-cinema trigger ush-cinema" [ngClass]="{ active: i === currentIndex }">
                          <img
                            class="ush-cinema-logo"
                            [src]="performance.cinema.imageUrl | img: { placeholder: defaultCinemaPlaceholder }"
                            [alt]="performance.cinema.name"
                            (error)="handleCinemaErrorImg($event)"
                          />
                          <div class="ush-cinema-info">
                            <div class="showtime-text-info">
                              <span class="ush-cinema-name" [title]="performance?.cinema?.name">
                                <strong>{{ performance?.cinema?.name }}</strong>
                                @if (performance?.distanceLiteral) {
                                  {{ ' (' + performance?.distanceLiteral + ')' }}
                                }
                              </span>
                            </div>
                            <span class="ush-cinema-address" [title]="performance.cinema.place.address">
                              <fa-icon [icon]="locationIcon" class="ush-cinema-address-marker"></fa-icon>
                              <span class="ush-cinema-address--place">{{ performance.cinema.place.address }}</span
                              >{{ performance.cinema.place.address ? ',' : '' }}
                              <span class="ush-cinema-address--city">{{ performance.cinema.place.city.name }}</span>
                            </span>
                          </div>
                          <div class="ush-cinema-check-msg-wrap">
                            <div class="ush-cinema-check-msg">
                              <div class="ush-cinema-check-msg-inside">
                                <div class="ush-cinema-check-msg-chevron">
                                  <fa-icon [icon]="chevronDownIcon" class="ush-cinema-check-msg-chevron-down"></fa-icon>
                                  <fa-icon [icon]="chevronUpIcon" class="ush-cinema-check-msg-chevron-up"></fa-icon>
                                </div>
                                <span
                                  class="ush-cinema-check-msg-message"
                                  i18n="@@public.commons.checkShowtimes"
                                  data-translate="public.commons.checkShowtimes"
                                >
                                  {{ 'public.commons.checkShowtimes' | rt: 'Check showtimes' }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <ush-performance [perfGroup]="performance" [showtimesFlow]="showtimesFlow()" />
                    </ng-template>
                  </p-accordionTab>
                }
              </p-accordion>
            }

            @if (!allItemsVisible()) {
              <ush-load-more-cinemas (click)="loadMore()" />
            }

            <div class="ush-showtimes-nearestCities-wrapper" *ngIf="!diasbleNearestCities && nearestCities?.length > 0">
              <p class="ush-showtimes-nearestCities-title">
                <span
                  data-translate="public.commons.nearestCities.availableAt"
                  i18n="@@public.commons.nearestCities.availableAt"
                >
                  {{ 'public.commons.nearestCities.availableAt' | rt: 'Showtimes also available at' }}</span
                >
              </p>
              <ul class="ush-showtimes-nearestCities-list">
                <li class="ush-showtimes-nearestCities-item" *ngFor="let city of nearestCities">
                  <button class="ush-showtime-nearestCities-btn button" (click)="onNearCitySelected(city)">
                    {{ city.name }} ({{ city.formatDistance }})
                  </button>
                </li>
              </ul>
            </div>
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="loading" />
        }
      }
      <!-- LOCATION SHOWTIME FLOW -->

      <!-- If there is extra description here put in a templateRef -->
      <!-- TODO: have the cineamo widget as a component to be used here, we will probably use it for more clients in the future -->
      @if (
        inCinemasAddon !== undefined &&
        loadingShowtimes() === false &&
        hasMovieTwoYearsOld() === true &&
        (performances() == undefined || isPerformancesEmpty()) &&
        (nearestCities == undefined || nearestCities.length === 0)
      ) {
        <ng-container
          [ngTemplateOutlet]="inCinemasAddon"
          [ngTemplateOutletContext]="{
            $implicit: isDateFlow() ? isPerformancesEmpty() : isPerformancesUiEmpty()
          }"
        />
      }
    </div>
  </ng-container>
  <ng-container *ngIf="showUsheruLogo">
    <ush-usheru-logo [movie]="movie"></ush-usheru-logo>
  </ng-container>
</div>
<ng-template #loading>
  <div class="p-grid p-formgrid">
    <div class="p-field p-col-12 p-md-6">
      <p-skeleton height="4rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton height="4rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton height="4rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton width="8rem" height="2rem" styleClass="p-mb-2 p-mx-auto"></p-skeleton>
      <p-skeleton width="15rem" height="2rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton height="3rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton width="8rem" height="3rem" styleClass="p-mb-2 "></p-skeleton>
    </div>
  </div>
</ng-template>
